{
  "table": {
    "key": "Key",
    "ticker": "Ticker",
    "name": "Name",
    "exchange": "Exchange",
    "currency": "Currency",
    "currentPrice": "Current Price",
    "currencyCurrentPriceCAD": "Current Price (CAD)",
    "currencyCurrentPriceUSD": "Current Price (USD)",
    "originalCurrency": "Original Currency",
    "originalPrice": "Original Price",
    "primaryAssetClass": "Primary Asset Class",
    "secondaryAssetClass": "Secondary Asset Class",
    "substituteProduct": "Substitute",
    "description": "Description",
    "tradeSchedule": "Trade Schedule",
    "planned": "Planned",
    "noSchedule": "No schedule",
    "taxRank": "Tax Rank",
    "autoUpdatePrices": "Auto Update Prices",
    "fundSeries": "Fund Series",
    "cusip": "CUSIP",
    "fractional": "Fractional",
    "volatile": "Volatile",
    "tertiaryAssetClass": "Tertiary Asset Class",
    "waivedFeePercentage": "Waived Fee Percentage",
    "settlementDays": "Settlement Days",
    "url": "URL",
    "isin": "ISIN",
    "ric": "RIC",
    "type": "Type",
    "multiplier": "Multiplier",
    "yes": "Yes",
    "no": "No",
    "unselectAll": "Unselect all pages",
    "selectAll": "Select all pages",
    "selectAllMessage": "Total number of rows selected: <bold>{{rowsCount}}</bold>",
    "allTypes": {
      "CASH_EQUIVALENTS": "Cash Equivalents",
      "FIXED_INCOME": "Fixed Income",
      "EQUITY": "Equity",
      "MUTUAL_FUND": "Mutual Fund",
      "ETF": "ETF",
      "DERIVATIVES": "Derivatives",
      "ALTERNATIVE_INVESTMENTS": "Alternative Investments",
      "ANNUITY": "Annuity",
      "CURRENCY": "Currency",
      "OTHER": "Other"
    }
  },
  "productModal": {
    "editTitle": "Edit Product",
    "title": "Add to Product Shelf",
    "ticker": "Ticker",
    "name": "Name",
    "exchange": "Exchange",
    "originalCurrency": "Original Currency",
    "displayCurrency": "Display Currency",
    "primaryAssetClass": "Primary Asset Class",
    "secondaryAssetClass": "Secondary Asset Class",
    "tertiaryAssetClass": "Tertiary Asset Class",
    "substituteProduct": "Substitute Financial Product",
    "autoUpdatePrices": "Auto Update Prices",
    "organization": "Organization",
    "currentPrice": "Current Price",
    "currencyCurrentPriceCAD": "Current Price (CAD)",
    "currencyCurrentPriceUSD": "Current Price (USD)",
    "schedule": "Schedule",
    "illiquidMessage": "Add Trading Schedule",
    "nextDate": "Next date",
    "waivedFeePercentage": "Waived Fee Percentage (0 - 100%)",
    "taxRank": "Tax Rank",
    "volatile": "Volatile",
    "settlementDays": "Settlement Days",
    "archive": "Archive",
    "newProductToastMessage": "You have added a financial product",
    "updateProductToastMessage": "You have updated a financial product",
    "archiveToastMessage": "You have archived a financial product",
    "url": "URL",
    "isPartial": "Fractional",
    "download": "Download Price History",
    "noHistoryToastMessage": "{{ticker}} has no price history",
    "cusip": "CUSIP",
    "isin": "ISIN",
    "ric": "RIC",
    "alphaNumericErrorMessage": "Only AlphaNumeric characters are allowed.",
    "alphaNumericWithDotErrorMessage": "Only AlphaNumeric characters, possibly seperated by a dot, are allowed.",
    "zeroMultiplierErrorMessage": "Multiplier should not be zero.",
    "cusipLengthErrorMessage": "9 or 22 characters are required.",
    "isinLengthErrorMessage": "12 characters are required.",
    "type": "Type",
    "fundSeries": "Fund Series",
    "allTypes": {
      "CASH_EQUIVALENTS": "Cash Equivalents",
      "FIXED_INCOME": "Fixed Income",
      "EQUITY": "Equity",
      "MUTUAL_FUND": "Mutual Fund",
      "ETF": "ETF",
      "DERIVATIVES": "Derivatives",
      "ALTERNATIVE_INVESTMENTS": "Alternative Investments",
      "ANNUITY": "Annuity",
      "CURRENCY": "Currency",
      "OTHER": "Other"
    },
    "multiplier": "Multiplier",
    "duplicateProductErrorMessage": "This product already exists. Please select a different ticker, exchange, or organization combination.",
    "currencyWarningMessage": "Warning: Original currency ({{originalCurrency}}) differs from the exchange's default currency ({{exchangeCurrency}}).",
    "originalPrice": "Original Price"
  },
  "assetClassModal": {
    "editTitle": "Edit Asset Class",
    "title": "Create new Asset Class",
    "key": "Key",
    "name": "Name",
    "description": "Description",
    "archive": "Archive",
    "newAssetClassToastMessage": "You have added an asset class",
    "archiveToastMessage": "You have archived an asset class"
  },
  "newGoalModal": {
    "title": "Add New Goal"
  },
  "filters": {
    "isScheduled": "Planned",
    "hasSubstitute": "Has Substitute Products",
    "primaryAssetClass": "Primary Asset Class",
    "exchange": "Exchange",
    "secondaryAssetClass": "Secondary Asset Class",
    "moreFilters": "Filters",
    "clearFilters": "Clear filters",
    "autoUpdatePrices": "Auto Update Prices"
  },
  "holdingDetailView": "Holding Detail View",
  "tabs": {
    "details": "Details",
    "auditLog": "Audit Log"
  },
  "auditLog": {
    "searchByProduct": "Search by Product",
    "startDate": "From",
    "endDate": "To",
    "emptyState": "Apply at least one filter to view audit logs",
    "errorLoading": "Could not load audit log",
    "invalidDateRange": "End date must be on or after the start date.",
    "clearDates": "Clear dates"
  }
}
